var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 301.93 364.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#da7736;}.cls-23,.cls-3{fill:#d35a35;}.cls-4{fill:#f28a39;}.cls-5{fill:#94c137;}.cls-6{fill:#f29c62;}.cls-7{fill:#f49c59;}.cls-27,.cls-8{fill:#e94e1b;}.cls-9{fill:#cb511e;opacity:0.53;}.cls-10{fill:#e17c38;}.cls-11{fill:#f6f2e7;}.cls-12{fill:#1d1d1b;}.cls-13,.cls-18{fill:#75952c;}.cls-14{fill:#e2dbc8;}.cls-15{fill:#f29d64;}.cls-16{fill:#e98c5d;}.cls-17{fill:#b0cb54;}.cls-18{opacity:0.75;}.cls-19{fill:#dc722f;}.cls-20{fill:#bad181;}.cls-21{fill:#e17732;opacity:0.86;}.cls-22{fill:#e17836;}.cls-23{opacity:0.44;}.cls-24{fill:#d86a2e;}.cls-25{fill:#c25834;}.cls-26{fill:#ca622d;}.cls-27{opacity:0.43;mix-blend-mode:multiply;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "65.19 304.89 55.67 338.64 118.48 356.36 126.17 322.09 65.19 304.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.22,329.59s8.56,18,42.75,6c0,0-29.92-21.71-35.78-30.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55.64,329.56c5-.15,12.46.77,16.83,6.71,0,0,19.36-2,23.62,6.67,0,0,19.11-2.13,24.1,6.8,0,0,5.46,18.71-39.56,7.08,0,0-34.08-5.65-33.43-19.34A8.56,8.56,0,0,1,55.64,329.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M75,343.2S86.12,338.52,92,348Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.14,349.75s11.17-4.68,17.09,4.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M50.32,336.25s11.17-4.68,17.08,4.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M47.74,335s16-3.92,22.47,5.52c0,0,19.47-2.71,24.35,5.66,0,0,18.92-4.55,25.63,3.6,0,0-3.77-8.05-24.1-6.8,0,0-3.41-8.68-23.62-6.67,0,0-4-7.67-16.83-6.71C55.64,329.56,47.82,329.34,47.74,335Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51,345.34s51.4,13.39,63.18,13.93C114.22,359.27,73.68,362,51,345.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M238.56,65.93S253,33.81,238.56,0c0,0-25.28,62.55-44.55,65.93C194,65.93,230.13,59.17,238.56,65.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M243.05,13.92s-4,.54-9.49-2.39L231.49,16a19.88,19.88,0,0,0,12.42,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M244.72,25s-9.78,0-15.4-4.56l-3.55,7S232.07,33.56,245,33C245,33,244.89,26.89,244.72,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M244.54,41.33s-13.89.71-21.84-8.1l-3.52,6.14s8.29,9.16,24.48,8.44C243.66,47.81,244.49,41.9,244.54,41.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M242.17,54.9S230,56.3,216.28,44.09l-5.77,9.64,28.08,12.2S241.45,58,242.17,54.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M238.56,0s14.37,25.44,0,65.93l-10.23-4.45S249.54,26.2,238.56,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M59.47,65.93S45,33.81,59.47,0c0,0,25.28,62.55,44.54,65.93C104,65.93,67.89,59.17,59.47,65.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M55,13.92s4,.54,9.49-2.39L66.57,16a19.9,19.9,0,0,1-12.42,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.33,25s9.79,0,15.4-4.56l3.56,7S66,33.56,53.05,33C53.05,33,53.16,26.89,53.33,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.51,41.33s13.89.71,21.85-8.1l3.51,6.14s-8.28,9.16-24.48,8.44C54.39,47.81,53.57,41.9,53.51,41.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M55.88,54.9s12.17,1.4,25.89-10.81l5.77,9.64L59.47,65.93S56.6,58,55.88,54.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.47,0s3.18,43.8,17.09,58.5l6.63-12S69.14,22.42,59.47,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "163.02 324.07 171.1 358.2 234.61 343.15 224.68 309.47 163.02 324.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M175.6,358.18c11.33-9.23,44.55-36.72,50-45.66L168,344.87l2.76,11.64A3,3,0,0,0,175.6,358.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.11,348.27c4.28-2.55,11.26-5.38,18-2.31,0,0,15.92-11.2,23.87-5.66,0,0,15.68-11.14,24.38-5.77,0,0,13.86,13.7-31.13,25.42,0,0-32.53,11.63-38.62-.65A8.56,8.56,0,0,1,175.11,348.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M239.61,288.3c0,30.85-40.5,55.86-90.46,55.86s-90.47-25-90.47-55.86l.1-2.33A37.08,37.08,0,0,1,63,271.31C70.21,233,59.11,172.71,51,137.18a62.43,62.43,0,0,1-7.19-28.83c0-43.81,47-79.32,105.07-79.32S254,64.54,254,108.35l-.22,4.85a62.28,62.28,0,0,1-4.82,19.45c-8.28,35.38-21,101.17-12.52,140.93a37.2,37.2,0,0,1,2.88,10.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M144,94.83c0,14-11.36,15.56-25.37,15.56s-25.38-1.54-25.38-15.56a25.38,25.38,0,0,1,50.75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M144.15,94.83a15.45,15.45,0,0,1-2.41,8.85l-.69.94c-.26.29-.55.54-.82.82a12.57,12.57,0,0,1-1.81,1.44,21.17,21.17,0,0,1-2,1.1,21.76,21.76,0,0,1-2.17.8,40.81,40.81,0,0,1-9.13,1.45c-3.08.19-6.17.21-9.25.17a63.31,63.31,0,0,1-9.23-.7A19.62,19.62,0,0,1,98,106.4a12.18,12.18,0,0,1-4.63-7.92,24.92,24.92,0,0,1,.22-9.31A25.39,25.39,0,0,1,103.67,73.8a25.61,25.61,0,0,1,40.48,21Zm-.26,0a25.15,25.15,0,0,0-49.63-5.5,24.24,24.24,0,0,0-.4,9.06,11.69,11.69,0,0,0,4.33,7.73,19.41,19.41,0,0,0,8.44,3.41,61.53,61.53,0,0,0,9.2.79c3.08.05,6.17.06,9.25-.11a37.84,37.84,0,0,0,9.11-1.47,21.84,21.84,0,0,0,2.17-.81,19.83,19.83,0,0,0,2-1.11,11.35,11.35,0,0,0,1.79-1.45c.26-.27.55-.53.8-.82l.66-.94A15.25,15.25,0,0,0,143.89,94.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M212.06,94.83c0,14-11.36,18.36-25.37,18.36s-25.37-4.34-25.37-18.36,11.36-22.56,25.37-22.56S212.06,80.82,212.06,94.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M212.3,94.83a18.84,18.84,0,0,1-2.15,9,16.07,16.07,0,0,1-6.7,6.22,28.2,28.2,0,0,1-8.79,2.65,55.37,55.37,0,0,1-9.19.51,46.79,46.79,0,0,1-9.14-1,23.51,23.51,0,0,1-8.47-3.49,14.65,14.65,0,0,1-5.62-7.19,22.54,22.54,0,0,1,1.69-18,21.12,21.12,0,0,1,6.27-6.86,29.14,29.14,0,0,1,17.72-4.87,31.09,31.09,0,0,1,9.16,1.69,24.52,24.52,0,0,1,8,4.7,21,21,0,0,1,5.43,7.54A23.3,23.3,0,0,1,212.3,94.83Zm-.48,0A22.44,22.44,0,0,0,210,86a20.31,20.31,0,0,0-5.37-7.18,23.85,23.85,0,0,0-7.83-4.4,30.13,30.13,0,0,0-8.87-1.61,28.41,28.41,0,0,0-17.23,4.54,21.54,21.54,0,0,0-8.13,24.09,14.4,14.4,0,0,0,5.4,7.18,23.31,23.31,0,0,0,8.41,3.52,46,46,0,0,0,9.13,1,53.16,53.16,0,0,0,9.18-.57,27.7,27.7,0,0,0,8.72-2.73,15.6,15.6,0,0,0,6.5-6.22A18.39,18.39,0,0,0,211.82,94.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.61,338.65c9.65-34.21-9-82.13-34.87-76.3-18.79,4.23-56.18,37.89-34.87,76.3C110.7,341.08,177.21,350.72,180.61,338.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M200.74,350.31s7.49-9.52,17.27-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M224.2,344.75s7.48-9.52,17.27-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M175.84,356.2s7.49-9.51,17.27-4.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 82.28,
    cy: 129.13,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 76.89,
    cy: 134.05,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 91.5,
    cy: 131.91,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 84.69,
    cy: 135.37,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 98.51,
    cy: 135.77,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 95.13,
    cy: 141.92,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 108.56,
    cy: 134.3,
    r: 1.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M186.69,73s23.87,4.5,22.11,26.2c0,0-.28,5.89-6.77,11.2,0,0,7.73-2,9.37-11.42a22.19,22.19,0,0,0-9.15-21.85C198.38,74.42,194,72.56,186.69,73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M125.7,71.1s14.94,8.9,13.18,21.2c0,0,.39,12.82-10,17.58,0,0,17.93.51,14.68-20C143.54,89.92,140.51,75.52,125.7,71.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M105.76,254.07c0,.84,0,1.67,0,2.5s0,1.65,0,2.5a6.07,6.07,0,0,1-.31-2.5A13.15,13.15,0,0,1,105.76,254.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M100.86,258.83a18.15,18.15,0,0,0-.34,2.52,6.17,6.17,0,0,0,.34,2.48,2.69,2.69,0,0,1-.56-1.18,4.44,4.44,0,0,1-.06-1.31A7.47,7.47,0,0,1,100.86,258.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M109.42,260.12a20.7,20.7,0,0,0-.5,2.59,5.9,5.9,0,0,0,0,1.26,2.12,2.12,0,0,0,.5,1.15,1.5,1.5,0,0,1-.89-1.06,3.32,3.32,0,0,1,0-1.4A6.4,6.4,0,0,1,109.42,260.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M111.45,249.23a24.47,24.47,0,0,0-.26,2.52,8,8,0,0,0,.26,2.48,2.66,2.66,0,0,1-.54-1.18,4.83,4.83,0,0,1-.07-1.31A7.7,7.7,0,0,1,111.45,249.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M105.38,267.1c0,.85,0,1.68,0,2.51s.09,1.61,0,2.49a2.79,2.79,0,0,1-.45-1.22,8,8,0,0,1,0-1.29A8.8,8.8,0,0,1,105.38,267.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M144.77,261c0,.84,0,1.67,0,2.5s0,1.65,0,2.5a6.47,6.47,0,0,1-.31-2.5A14,14,0,0,1,144.77,261Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M148.43,267.08a22.68,22.68,0,0,0-.5,2.59,5.3,5.3,0,0,0,0,1.26,2.1,2.1,0,0,0,.49,1.15,1.53,1.53,0,0,1-.88-1.06,3.33,3.33,0,0,1-.06-1.4A6.66,6.66,0,0,1,148.43,267.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M150.47,256.19a19.94,19.94,0,0,0-.26,2.52,8,8,0,0,0,.26,2.48,2.71,2.71,0,0,1-.55-1.19,4.79,4.79,0,0,1-.07-1.31A7.72,7.72,0,0,1,150.47,256.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M144.39,274.05c0,.85,0,1.69,0,2.51s.09,1.62,0,2.49a2.83,2.83,0,0,1-.45-1.21,7,7,0,0,1,0-1.29A9.3,9.3,0,0,1,144.39,274.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M129.29,327.05a18.12,18.12,0,0,0-.33,2.52,6.16,6.16,0,0,0,.33,2.48,2.69,2.69,0,0,1-.56-1.18,4.44,4.44,0,0,1-.06-1.31A7.71,7.71,0,0,1,129.29,327.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M137.85,328.34a20.7,20.7,0,0,0-.5,2.59,5.3,5.3,0,0,0,0,1.26,2,2,0,0,0,.49,1.15,1.52,1.52,0,0,1-.89-1.06,3.31,3.31,0,0,1-.05-1.4A6.4,6.4,0,0,1,137.85,328.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M139.89,317.45a22,22,0,0,0-.27,2.53,7.72,7.72,0,0,0,.27,2.47,2.57,2.57,0,0,1-.55-1.18,4.83,4.83,0,0,1-.07-1.31A7.47,7.47,0,0,1,139.89,317.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M133.81,335.32c0,.85,0,1.68,0,2.51s.09,1.61,0,2.49a2.74,2.74,0,0,1-.45-1.22,7.86,7.86,0,0,1,0-1.28A9.16,9.16,0,0,1,133.81,335.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M157.46,279.6c0,.84,0,1.68,0,2.51s0,1.64,0,2.49a6.43,6.43,0,0,1-.31-2.5A14,14,0,0,1,157.46,279.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M152.57,284.36a17.06,17.06,0,0,0-.34,2.53,6.12,6.12,0,0,0,.34,2.47,2.54,2.54,0,0,1-.56-1.18,4.44,4.44,0,0,1-.07-1.31A7.48,7.48,0,0,1,152.57,284.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M161.12,285.65a22.43,22.43,0,0,0-.5,2.6,5.3,5.3,0,0,0,0,1.26,2.07,2.07,0,0,0,.49,1.14,1.51,1.51,0,0,1-.88-1.06,3.31,3.31,0,0,1-.06-1.4A6.72,6.72,0,0,1,161.12,285.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M163.16,274.76a19.91,19.91,0,0,0-.26,2.53,8.06,8.06,0,0,0,.26,2.48,2.76,2.76,0,0,1-.55-1.19,4.81,4.81,0,0,1-.07-1.31A7.71,7.71,0,0,1,163.16,274.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M161.29,305.38c0,.84,0,1.67,0,2.51s0,1.64,0,2.49a6.25,6.25,0,0,1-.32-2.5A14,14,0,0,1,161.29,305.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M156.39,310.14a18.49,18.49,0,0,0-.34,2.53,6.12,6.12,0,0,0,.34,2.47,2.64,2.64,0,0,1-.56-1.18,4.81,4.81,0,0,1-.07-1.31A7.72,7.72,0,0,1,156.39,310.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M164.94,311.43a24.76,24.76,0,0,0-.5,2.6,5.31,5.31,0,0,0,0,1.26,2.07,2.07,0,0,0,.49,1.14,1.51,1.51,0,0,1-.88-1.06A3.48,3.48,0,0,1,164,314,6.72,6.72,0,0,1,164.94,311.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M160.9,318.41c0,.85,0,1.68,0,2.51s.09,1.61,0,2.49a2.82,2.82,0,0,1-.45-1.22,7.85,7.85,0,0,1,0-1.28A9.15,9.15,0,0,1,160.9,318.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M126.86,270.56c0,.84,0,1.67,0,2.5s0,1.65,0,2.5a6.5,6.5,0,0,1-.31-2.51A13.9,13.9,0,0,1,126.86,270.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M122,275.31a18.49,18.49,0,0,0-.34,2.53,6.12,6.12,0,0,0,.34,2.47,2.64,2.64,0,0,1-.56-1.18,4.43,4.43,0,0,1-.07-1.31A7.48,7.48,0,0,1,122,275.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M130.52,276.61a24.1,24.1,0,0,0-.5,2.59,5.3,5.3,0,0,0,0,1.26,2.1,2.1,0,0,0,.49,1.15,1.53,1.53,0,0,1-.88-1.06,3.5,3.5,0,0,1-.06-1.4A6.66,6.66,0,0,1,130.52,276.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M132.56,265.72a19.76,19.76,0,0,0-.26,2.52,8,8,0,0,0,.26,2.48,2.71,2.71,0,0,1-.55-1.19,5.22,5.22,0,0,1-.07-1.31A7.65,7.65,0,0,1,132.56,265.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M94.13,273.07c0,.84,0,1.68,0,2.51s0,1.64,0,2.49a6.07,6.07,0,0,1-.31-2.5A13.15,13.15,0,0,1,94.13,273.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M89.23,277.83a18.46,18.46,0,0,0-.33,2.53,6.11,6.11,0,0,0,.33,2.47,2.64,2.64,0,0,1-.56-1.18,4.42,4.42,0,0,1-.06-1.31A7.71,7.71,0,0,1,89.23,277.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M97.79,279.12a20.5,20.5,0,0,0-.5,2.6,5.3,5.3,0,0,0,0,1.26,2.06,2.06,0,0,0,.49,1.15,1.56,1.56,0,0,1-.89-1.07,3.31,3.31,0,0,1-.05-1.4A6.72,6.72,0,0,1,97.79,279.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M99.83,268.24a21.55,21.55,0,0,0-.27,2.52,8.07,8.07,0,0,0,.27,2.48,2.65,2.65,0,0,1-.55-1.19,4.81,4.81,0,0,1-.07-1.31A7.35,7.35,0,0,1,99.83,268.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M93.75,286.1c0,.85,0,1.68,0,2.51s.09,1.62,0,2.49a2.7,2.7,0,0,1-.45-1.22,6.85,6.85,0,0,1,0-1.28A8.86,8.86,0,0,1,93.75,286.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M118.07,301.11a21.88,21.88,0,0,0-.5,2.59,5.3,5.3,0,0,0,0,1.26,2.1,2.1,0,0,0,.49,1.15,1.5,1.5,0,0,1-.88-1.06,3.17,3.17,0,0,1-.06-1.4A6.66,6.66,0,0,1,118.07,301.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M114,308.08c0,.85,0,1.69,0,2.51s.09,1.62,0,2.49a2.83,2.83,0,0,1-.45-1.21,7,7,0,0,1,0-1.29A9.3,9.3,0,0,1,114,308.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M96.72,300.53c0,.84,0,1.67,0,2.5s0,1.65,0,2.5a6.47,6.47,0,0,1-.31-2.5A13.15,13.15,0,0,1,96.72,300.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M91.83,305.29a16.75,16.75,0,0,0-.34,2.52,6,6,0,0,0,.34,2.48,2.53,2.53,0,0,1-.56-1.18,4.14,4.14,0,0,1-.07-1.31A7.42,7.42,0,0,1,91.83,305.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M100.38,306.58a22.68,22.68,0,0,0-.5,2.59,5.3,5.3,0,0,0,0,1.26,2.1,2.1,0,0,0,.49,1.15,1.5,1.5,0,0,1-.88-1.06,3.17,3.17,0,0,1-.06-1.4A6.66,6.66,0,0,1,100.38,306.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M102.42,295.69a19.94,19.94,0,0,0-.26,2.52,7.74,7.74,0,0,0,.26,2.48,2.61,2.61,0,0,1-.55-1.19,4.79,4.79,0,0,1-.07-1.31A7.47,7.47,0,0,1,102.42,295.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M96.34,313.55c0,.85,0,1.69,0,2.51s.09,1.62,0,2.49a2.83,2.83,0,0,1-.45-1.21,7,7,0,0,1,0-1.29A9.3,9.3,0,0,1,96.34,313.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M179.65,295.36a16.75,16.75,0,0,1,.34,2.52,6.17,6.17,0,0,1-.34,2.48,2.49,2.49,0,0,0,.56-1.18,4.44,4.44,0,0,0,.07-1.31A7.48,7.48,0,0,0,179.65,295.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M169.06,285.76a19.94,19.94,0,0,1,.26,2.52,7.74,7.74,0,0,1-.26,2.48,2.57,2.57,0,0,0,.55-1.18,4.83,4.83,0,0,0,.07-1.31A7.47,7.47,0,0,0,169.06,285.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M175.14,303.63c0,.85,0,1.68,0,2.51s-.09,1.61,0,2.49a2.92,2.92,0,0,0,.45-1.22,7,7,0,0,0,0-1.29A9.15,9.15,0,0,0,175.14,303.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M177,317.07c0,.84,0,1.67,0,2.5s0,1.65,0,2.5a6.27,6.27,0,0,0,.32-2.5A14,14,0,0,0,177,317.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M181.85,321.83a18.15,18.15,0,0,1,.34,2.52,6.19,6.19,0,0,1-.34,2.48,2.74,2.74,0,0,0,.56-1.18,4.45,4.45,0,0,0,.06-1.31A7.41,7.41,0,0,0,181.85,321.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M173.3,323.12a22.61,22.61,0,0,1,.49,2.59,5.31,5.31,0,0,1,0,1.26,2.1,2.1,0,0,1-.49,1.15,1.53,1.53,0,0,0,.88-1.06,3.5,3.5,0,0,0,.06-1.4A6.66,6.66,0,0,0,173.3,323.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M171.26,312.23a24.47,24.47,0,0,1,.26,2.52,8,8,0,0,1-.26,2.48,2.7,2.7,0,0,0,.54-1.19,4.43,4.43,0,0,0,.07-1.31A7.46,7.46,0,0,0,171.26,312.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M177.34,330.09c0,.85,0,1.69,0,2.51s-.1,1.62,0,2.49a3,3,0,0,0,.45-1.21,9,9,0,0,0-.45-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M171.1,277a22.68,22.68,0,0,1,.5,2.59,5.3,5.3,0,0,1,0,1.26,2.1,2.1,0,0,1-.49,1.15,1.48,1.48,0,0,0,.88-1.06,3.17,3.17,0,0,0,.06-1.4A6.72,6.72,0,0,0,171.1,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M175.14,284c0,.85,0,1.68,0,2.51s-.09,1.61,0,2.49a2.87,2.87,0,0,0,.45-1.22,6.87,6.87,0,0,0,0-1.28A9.15,9.15,0,0,0,175.14,284Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M207.78,278.49c0,.84,0,1.67,0,2.5s0,1.65,0,2.5a6.07,6.07,0,0,0,.31-2.5A13.15,13.15,0,0,0,207.78,278.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M212.68,283.25a18.06,18.06,0,0,1,.33,2.53,6.13,6.13,0,0,1-.33,2.47,2.69,2.69,0,0,0,.56-1.18,4.44,4.44,0,0,0,.06-1.31A7.71,7.71,0,0,0,212.68,283.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M204.12,284.54a20.5,20.5,0,0,1,.5,2.6,5.31,5.31,0,0,1,0,1.26,2,2,0,0,1-.49,1.14,1.52,1.52,0,0,0,.89-1.06,3.31,3.31,0,0,0,.05-1.4A6.72,6.72,0,0,0,204.12,284.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M202.08,273.65a22,22,0,0,1,.27,2.53,8,8,0,0,1-.27,2.47,2.57,2.57,0,0,0,.55-1.18,4.83,4.83,0,0,0,.07-1.31A7.47,7.47,0,0,0,202.08,273.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M208.16,291.52c0,.85,0,1.68,0,2.51s-.09,1.61,0,2.49a2.7,2.7,0,0,0,.45-1.22,6.87,6.87,0,0,0,0-1.28A8.79,8.79,0,0,0,208.16,291.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M193.63,280.45c0,.84,0,1.67,0,2.5s0,1.65,0,2.5A6.27,6.27,0,0,0,194,283,13.16,13.16,0,0,0,193.63,280.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M198.53,285.21a18.15,18.15,0,0,1,.34,2.52,6.19,6.19,0,0,1-.34,2.48,2.69,2.69,0,0,0,.56-1.18,4.83,4.83,0,0,0,.07-1.31A7.48,7.48,0,0,0,198.53,285.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M190,286.5a25.09,25.09,0,0,1,.5,2.59,5.3,5.3,0,0,1,0,1.26,2.1,2.1,0,0,1-.49,1.15,1.51,1.51,0,0,0,.88-1.06,3.5,3.5,0,0,0,.06-1.4A6.66,6.66,0,0,0,190,286.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M187.94,275.61a19.94,19.94,0,0,1,.26,2.52,8,8,0,0,1-.26,2.48,2.83,2.83,0,0,0,.55-1.19,5.16,5.16,0,0,0,.07-1.3A7.71,7.71,0,0,0,187.94,275.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M194,293.47c0,.85,0,1.69,0,2.51s-.09,1.62,0,2.5a2.92,2.92,0,0,0,.45-1.22,7.94,7.94,0,0,0,0-1.29A9.3,9.3,0,0,0,194,293.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M200.2,316.55c0,.84,0,1.67,0,2.5s0,1.65,0,2.5a6.09,6.09,0,0,0,.31-2.5A13.15,13.15,0,0,0,200.2,316.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M205.1,321.31a18.12,18.12,0,0,1,.33,2.52,6.16,6.16,0,0,1-.33,2.48,2.69,2.69,0,0,0,.56-1.18,4.45,4.45,0,0,0,.06-1.31A7.71,7.71,0,0,0,205.1,321.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M196.54,322.6a20.7,20.7,0,0,1,.5,2.59,5.3,5.3,0,0,1,0,1.26,2,2,0,0,1-.49,1.15,1.52,1.52,0,0,0,.89-1.06,3.32,3.32,0,0,0,0-1.4A6.56,6.56,0,0,0,196.54,322.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M194.5,311.71a22,22,0,0,1,.27,2.52,8,8,0,0,1-.27,2.48,2.61,2.61,0,0,0,.55-1.19,4.74,4.74,0,0,0,.07-1.3A7.47,7.47,0,0,0,194.5,311.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M200.58,329.58c0,.84,0,1.68,0,2.5s-.09,1.62,0,2.5a2.79,2.79,0,0,0,.45-1.22,8,8,0,0,0,0-1.29A9.17,9.17,0,0,0,200.58,329.58Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 120.09,
    cy: 91.78,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 184,
    cy: 91.78,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 118.65,
    cy: 88.68,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 183.05,
    cy: 88.68,
    r: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M118.31,303.09a14.29,14.29,0,0,0,14.29-14.3c0-5.4-4.33-10.8-8.76-13.23a60.64,60.64,0,0,0-15.91,22.3C110.51,300.36,114.44,303.09,118.31,303.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M178.7,289c-4-10.09-8.82-18.15-15.86-22.52-4.17,2.49-8.78,8-8.78,13.19a14.29,14.29,0,0,0,14.29,14.29C172.11,293.91,176.15,291.32,178.7,289Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M183.77,316.79a19.82,19.82,0,1,0-28,26.79c12.74.38,23.55-.46,24.8-4.2A66.48,66.48,0,0,0,183.77,316.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M105.84,325.31a49.27,49.27,0,0,0,4,11.78c.86,1.79,2.85,2.52,4.82,2.79,4.41.58,12.79,2.18,22.46,3.05,0-.49.07-1,.07-1.5a19.81,19.81,0,0,0-31.35-16.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M118.22,157l69-2.18s5.24,16.09-31.14,9.11C156.05,163.88,119.21,174.53,118.22,157Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122.49,144.72c10.54-3.64,30.05-7.69,56.73-1.9,10.41,2.26,10.73,17.11.36,19.59-5.93,1.42-16.32-3.77-25.93-5.35,0,0-18.73,14-33.91,1.55C114.89,154.62,116.55,146.76,122.49,144.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M117.21,154.77S135,136.2,183.05,144.48c0,0-25.15-11.25-62.07.5C121,145,114.31,147.42,117.21,154.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M117.94,156.49s18.29,9.84,33.66-.81a2.9,2.9,0,0,1,2.64-.39c6.09,2.21,30.14,10.16,32.95-.52,0,0-1.92,16.82-33.54,2.29C153.65,157.06,131.26,173.62,117.94,156.49Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 82.82,
    cy: 128.89,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 77.44,
    cy: 133.81,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 92.05,
    cy: 131.67,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 85.24,
    cy: 135.13,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 99.06,
    cy: 135.52,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 95.68,
    cy: 141.68,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 109.11,
    cy: 134.06,
    r: 1.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M171.11,358.2s12.59-12.62,22.59-8.79c0,0,14.59-11.65,23.34-6.71,0,0,13.62-8.55,19.07-9.62,0,0-13,.67-19.16,7.22,0,0-6.39-6.56-23.87,5.66,0,0-9.5-6.26-20.85,5.05C172.23,351,169.05,354.92,171.11,358.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.76,364.91s50.65-12.46,57.36-23.48C243.12,341.43,240.26,358.35,185.76,364.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M59.83,297.19c9.79,31.6,47.64,40.7,47.64,40.7s-24.63-5.13-37.93-74.06l-5.32-1.21L63,271.31S55.59,283.53,59.83,297.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M59.47,65.93A54.7,54.7,0,0,0,83.19,46.46S69.71,54.76,59.47,65.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M238.21,65.93a54.75,54.75,0,0,1-23.73-19.47S228,54.76,238.21,65.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M242.17,135.37c10.7-31.76-4-69.44-4-69.44,25.84,31.29,12.89,62.08,10.95,66.24-.19.4-.35.77-.5,1.18C242,151.37,234.59,219,234.59,219l-2.15,20.13S232.08,165.34,242.17,135.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M60.35,136.8c-14.65-33.41-4.47-65.34-4.47-65.34-23,31.16-4.85,65.72-4.85,65.72,9.31,28.79,13.5,84.57,13.5,84.57-.42,4.64,5,22.61,5,22.61L63.1,148.2A34,34,0,0,0,60.35,136.8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 204.03,
    cy: 128.89,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 198.64,
    cy: 133.81,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 213.25,
    cy: 131.67,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 206.45,
    cy: 135.13,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 220.27,
    cy: 135.52,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 216.89,
    cy: 141.68,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 230.32,
    cy: 134.06,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 203.18,
    cy: 128.89,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 197.79,
    cy: 133.81,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 212.4,
    cy: 131.67,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 205.6,
    cy: 135.13,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 219.42,
    cy: 135.52,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 216.04,
    cy: 141.68,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 229.47,
    cy: 134.06,
    r: 1.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.7,263.48S28.38,256,3.45,216.27c0,0-11-21,15.85-17.92,0,0,15.76-25.77,28.21-8.3a15.36,15.36,0,0,1,2.74,10.61c-1.12,10-.58,33.45,29.35,34.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M67.7,263.48a90.6,90.6,0,0,1-19.21-6.82A105.4,105.4,0,0,1,31,246.18a104.1,104.1,0,0,1-15.27-13.57l-1.75-1.87c-.29-.31-.59-.61-.87-.94l-.8-1-3.22-4a49,49,0,0,1-3-4.14l-2.91-4.22h0a21.75,21.75,0,0,1-2.26-7.9,11.68,11.68,0,0,1,.41-4.15,8.08,8.08,0,0,1,2.21-3.6,10.25,10.25,0,0,1,3.62-2.13,17.72,17.72,0,0,1,2-.58c.67-.12,1.36-.26,2-.33a38.63,38.63,0,0,1,8.19.11l-.48.23h0a41.49,41.49,0,0,1,3.51-5.26,37.31,37.31,0,0,1,4.25-4.74,23,23,0,0,1,5.28-3.81,12.68,12.68,0,0,1,6.61-1.53,11,11,0,0,1,3.43.79c.53.25,1,.51,1.56.79s1,.63,1.41,1,.88.73,1.28,1.12l1.15,1.22a25.91,25.91,0,0,1,2,2.7,16.34,16.34,0,0,1,2.22,6.35,17.27,17.27,0,0,1,.09,3.37l-.17,1.59c-.05.5-.1,1-.13,1.51a42,42,0,0,0,0,6,34.86,34.86,0,0,0,.88,5.95,24.5,24.5,0,0,0,5.34,10.57,25,25,0,0,0,10,6.63,44.51,44.51,0,0,0,12.09,2.46,41,41,0,0,1-12.42-1.46,25.21,25.21,0,0,1-11-6.41A25.62,25.62,0,0,1,50,215.74,40,40,0,0,1,48.75,203c0-.53.07-1.06.11-1.6L49,199.9a14.16,14.16,0,0,0-.13-2.84A13.87,13.87,0,0,0,47,191.73c-2-3.21-5-6.21-8.67-6.44a10.4,10.4,0,0,0-5.4,1.09,22.46,22.46,0,0,0-5,3.23,49.37,49.37,0,0,0-8.24,9h0l-.16.27-.32,0a37.4,37.4,0,0,0-8-.17c-.66.06-1.3.18-1.95.29a16.44,16.44,0,0,0-1.89.53,9.27,9.27,0,0,0-3.34,1.92,8.56,8.56,0,0,0-2.42,7.07,21.24,21.24,0,0,0,2.1,7.62v0L6.6,220.3c1,1.39,1.85,2.85,3,4.14l3.17,4,.79,1c.27.32.57.63.85.94l1.73,1.88a103.39,103.39,0,0,0,15.09,13.64A105,105,0,0,0,48.57,256.5,90.57,90.57,0,0,0,67.7,263.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M45,235.32c-.48-.69-1-1.36-1.47-2s-.95-1.34-1.51-2a6.19,6.19,0,0,0,1.24,2.19A13.62,13.62,0,0,0,45,235.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M38.21,234.42a19.09,19.09,0,0,1-1.78-1.82,6.25,6.25,0,0,1-1.2-2.19,2.72,2.72,0,0,0,.25,1.28,4.52,4.52,0,0,0,.73,1.09A7.5,7.5,0,0,0,38.21,234.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M44.31,228.28a22.29,22.29,0,0,1-2-1.78,5.57,5.57,0,0,1-.75-1,2.13,2.13,0,0,1-.29-1.21,1.52,1.52,0,0,0-.07,1.38A3.2,3.2,0,0,0,42,226.8,6.42,6.42,0,0,0,44.31,228.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M52.44,235.81a23.07,23.07,0,0,1-1.72-1.87,8.13,8.13,0,0,1-1.27-2.15,2.84,2.84,0,0,0,.27,1.28,4.52,4.52,0,0,0,.73,1.09A7.68,7.68,0,0,0,52.44,235.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M36.9,225.09c-.52-.67-1-1.32-1.53-2s-.89-1.35-1.45-2a2.87,2.87,0,0,0,.36,1.25,9.47,9.47,0,0,0,.74,1A9.24,9.24,0,0,0,36.9,225.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M38.74,218.57c-.48-.69-1-1.36-1.46-2s-1-1.35-1.52-2a6.3,6.3,0,0,0,1.24,2.2A14.25,14.25,0,0,0,38.74,218.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M32,217.67a18,18,0,0,1-1.77-1.83A6,6,0,0,1,29,213.65a2.65,2.65,0,0,0,.26,1.29A4.16,4.16,0,0,0,30,216,7.49,7.49,0,0,0,32,217.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M38.07,211.53a20.9,20.9,0,0,1-2-1.79,5.13,5.13,0,0,1-.74-1,2,2,0,0,1-.29-1.22,1.49,1.49,0,0,0-.08,1.38,3.27,3.27,0,0,0,.79,1.16A6.65,6.65,0,0,0,38.07,211.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M46.2,219.05a20.16,20.16,0,0,1-1.72-1.87A8,8,0,0,1,43.22,215a2.62,2.62,0,0,0,.27,1.28,4.9,4.9,0,0,0,.72,1.09A7.45,7.45,0,0,0,46.2,219.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M30.67,208.34c-.53-.67-1-1.33-1.53-2s-.89-1.35-1.46-2a2.84,2.84,0,0,0,.37,1.24,7.08,7.08,0,0,0,.74,1.05A8.79,8.79,0,0,0,30.67,208.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M164,319.13c0,.84,0,1.67,0,2.5s0,1.65,0,2.5a6.3,6.3,0,0,0,.32-2.5A13.9,13.9,0,0,0,164,319.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M168.93,323.88a18.49,18.49,0,0,1,.34,2.53,6.19,6.19,0,0,1-.34,2.48,2.73,2.73,0,0,0,.56-1.19,4.42,4.42,0,0,0,.06-1.31A7.47,7.47,0,0,0,168.93,323.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M160.38,325.18a24.1,24.1,0,0,1,.5,2.59,5.89,5.89,0,0,1,0,1.26,2.1,2.1,0,0,1-.49,1.15,1.53,1.53,0,0,0,.88-1.06,3.5,3.5,0,0,0,.06-1.4A6.66,6.66,0,0,0,160.38,325.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M158.34,314.29a24.47,24.47,0,0,1,.26,2.52,8,8,0,0,1-.26,2.48,2.7,2.7,0,0,0,.54-1.19,4.43,4.43,0,0,0,.07-1.31A7.46,7.46,0,0,0,158.34,314.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M164.42,332.15c0,.85,0,1.69,0,2.51s-.1,1.62,0,2.49a2.83,2.83,0,0,0,.45-1.21,9,9,0,0,0-.45-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M76,196.8c0,.84,0,1.67,0,2.5s0,1.65,0,2.5a6.47,6.47,0,0,1-.31-2.5A13.15,13.15,0,0,1,76,196.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M71.15,201.56a16.75,16.75,0,0,0-.34,2.52,6,6,0,0,0,.34,2.48,2.53,2.53,0,0,1-.56-1.18,4.14,4.14,0,0,1-.07-1.31A7.42,7.42,0,0,1,71.15,201.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M79.7,202.85a22.27,22.27,0,0,0-.5,2.59,5.3,5.3,0,0,0,0,1.26,2.1,2.1,0,0,0,.49,1.15,1.54,1.54,0,0,1-.89-1.06,3.32,3.32,0,0,1,0-1.4A6.66,6.66,0,0,1,79.7,202.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M81.74,192a19.94,19.94,0,0,0-.26,2.52,7.74,7.74,0,0,0,.26,2.48,2.61,2.61,0,0,1-.55-1.19,4.79,4.79,0,0,1-.07-1.31A7.47,7.47,0,0,1,81.74,192Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M75.66,209.82c0,.85,0,1.69,0,2.51s.09,1.62,0,2.49a2.83,2.83,0,0,1-.45-1.21,7,7,0,0,1,0-1.29A8.93,8.93,0,0,1,75.66,209.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M72.9,166.79c0,.84,0,1.67,0,2.5s0,1.65,0,2.5a6.11,6.11,0,0,1-.31-2.5A13.15,13.15,0,0,1,72.9,166.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M68,171.54a18.46,18.46,0,0,0-.33,2.53,6.18,6.18,0,0,0,.33,2.48,2.74,2.74,0,0,1-.56-1.18,4.51,4.51,0,0,1-.06-1.32A7.71,7.71,0,0,1,68,171.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M76.56,172.84a20,20,0,0,0-.5,2.59,5.3,5.3,0,0,0,0,1.26,2,2,0,0,0,.49,1.15,1.54,1.54,0,0,1-.89-1.06,3.32,3.32,0,0,1,0-1.4A6.5,6.5,0,0,1,76.56,172.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M78.6,162a22,22,0,0,0-.27,2.52A7.75,7.75,0,0,0,78.6,167a2.61,2.61,0,0,1-.55-1.19,4.79,4.79,0,0,1-.07-1.31A7.47,7.47,0,0,1,78.6,162Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M72.52,179.81c0,.85,0,1.69,0,2.51s.09,1.62,0,2.49a2.7,2.7,0,0,1-.45-1.21,8,8,0,0,1,0-1.29A9.31,9.31,0,0,1,72.52,179.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M64.47,141.48c0,.84,0,1.68,0,2.51s0,1.64,0,2.49a6.43,6.43,0,0,1-.31-2.5A14.12,14.12,0,0,1,64.47,141.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M59.58,146.24a18.49,18.49,0,0,0-.34,2.53,6.12,6.12,0,0,0,.34,2.47,2.64,2.64,0,0,1-.56-1.18,4.43,4.43,0,0,1-.07-1.31A7.48,7.48,0,0,1,59.58,146.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M68.13,147.54a24.1,24.1,0,0,0-.5,2.59,5.3,5.3,0,0,0,0,1.26,2.13,2.13,0,0,0,.49,1.15,1.54,1.54,0,0,1-.88-1.07,3.48,3.48,0,0,1-.06-1.4A6.62,6.62,0,0,1,68.13,147.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M70.17,136.65a19.76,19.76,0,0,0-.26,2.52,8,8,0,0,0,.26,2.48,2.76,2.76,0,0,1-.55-1.19,5.24,5.24,0,0,1-.07-1.31A7.59,7.59,0,0,1,70.17,136.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M64.09,154.51c0,.85,0,1.68,0,2.51s.09,1.62,0,2.49a2.82,2.82,0,0,1-.45-1.22,6.83,6.83,0,0,1,0-1.28A9.22,9.22,0,0,1,64.09,154.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M155.92,113c0,.84,0,1.67,0,2.5s0,1.65,0,2.5a6.32,6.32,0,0,0,.32-2.51A13.91,13.91,0,0,0,155.92,113Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M160.82,117.71a18.49,18.49,0,0,1,.34,2.53,6.12,6.12,0,0,1-.34,2.47,2.64,2.64,0,0,0,.56-1.18,4.42,4.42,0,0,0,.06-1.31A7.47,7.47,0,0,0,160.82,117.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M152.27,119a21.82,21.82,0,0,1,.49,2.59,5.31,5.31,0,0,1,0,1.26,2.1,2.1,0,0,1-.49,1.15,1.53,1.53,0,0,0,.88-1.06,3.5,3.5,0,0,0,.06-1.4A6.66,6.66,0,0,0,152.27,119Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M150.23,108.12a24.47,24.47,0,0,1,.26,2.52,8,8,0,0,1-.26,2.48,2.7,2.7,0,0,0,.54-1.19,4.43,4.43,0,0,0,.07-1.31A7.46,7.46,0,0,0,150.23,108.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M156.31,126c0,.85,0,1.68,0,2.51s-.1,1.62,0,2.49a3,3,0,0,0,.45-1.21,9,9,0,0,0-.45-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M227.55,78.85c0,.84,0,1.67,0,2.5s0,1.65,0,2.5a6.45,6.45,0,0,0,.31-2.5A13.15,13.15,0,0,0,227.55,78.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M232.44,83.61a16.75,16.75,0,0,1,.34,2.52,6.19,6.19,0,0,1-.34,2.48,2.49,2.49,0,0,0,.56-1.18,4.46,4.46,0,0,0,.07-1.31A7.48,7.48,0,0,0,232.44,83.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M223.89,84.9a22.68,22.68,0,0,1,.5,2.59,5.3,5.3,0,0,1,0,1.26,2.1,2.1,0,0,1-.49,1.15,1.48,1.48,0,0,0,.88-1.06,3.17,3.17,0,0,0,.06-1.4A6.72,6.72,0,0,0,223.89,84.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M221.85,74a19.94,19.94,0,0,1,.26,2.52,7.74,7.74,0,0,1-.26,2.48,2.61,2.61,0,0,0,.55-1.19,4.74,4.74,0,0,0,.07-1.3A7.47,7.47,0,0,0,221.85,74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M227.93,91.87c0,.85,0,1.69,0,2.51s-.09,1.62,0,2.5a2.92,2.92,0,0,0,.45-1.22,7,7,0,0,0,0-1.29A9.3,9.3,0,0,0,227.93,91.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M203.26,49.15c0,.84,0,1.67,0,2.5s0,1.65,0,2.5a6.07,6.07,0,0,0,.31-2.5A13.15,13.15,0,0,0,203.26,49.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M208.16,53.91a18.15,18.15,0,0,1,.34,2.52,6.17,6.17,0,0,1-.34,2.48,2.69,2.69,0,0,0,.56-1.18,4.44,4.44,0,0,0,.06-1.31A7.47,7.47,0,0,0,208.16,53.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M199.6,55.2a20.7,20.7,0,0,1,.5,2.59,5.9,5.9,0,0,1,0,1.26,2.12,2.12,0,0,1-.5,1.15,1.5,1.5,0,0,0,.89-1.06,3.32,3.32,0,0,0,0-1.4A6.4,6.4,0,0,0,199.6,55.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M197.56,44.31a22,22,0,0,1,.27,2.53,7.72,7.72,0,0,1-.27,2.47,2.57,2.57,0,0,0,.55-1.18,4.83,4.83,0,0,0,.07-1.31A7.47,7.47,0,0,0,197.56,44.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M203.64,62.18c0,.85,0,1.68,0,2.51s-.09,1.61,0,2.49a2.74,2.74,0,0,0,.45-1.22,7.86,7.86,0,0,0,0-1.28A9.16,9.16,0,0,0,203.64,62.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M87.46,56.57c0,.84,0,1.67,0,2.5s0,1.65,0,2.5a6.45,6.45,0,0,1-.31-2.5A14,14,0,0,1,87.46,56.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M82.57,61.33a18.15,18.15,0,0,0-.34,2.52,6.19,6.19,0,0,0,.34,2.48A2.69,2.69,0,0,1,82,65.15a4.46,4.46,0,0,1-.07-1.31A7.42,7.42,0,0,1,82.57,61.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M91.12,62.62a25.09,25.09,0,0,0-.5,2.59,5.3,5.3,0,0,0,0,1.26,2.1,2.1,0,0,0,.49,1.15,1.53,1.53,0,0,1-.88-1.06,3.5,3.5,0,0,1-.06-1.4A6.66,6.66,0,0,1,91.12,62.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M93.16,51.73a19.94,19.94,0,0,0-.26,2.52,8,8,0,0,0,.26,2.48,2.71,2.71,0,0,1-.55-1.19,5.16,5.16,0,0,1-.07-1.3A7.71,7.71,0,0,1,93.16,51.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M87.08,69.59c0,.85,0,1.69,0,2.51s.09,1.62,0,2.49a2.83,2.83,0,0,1-.45-1.21,7,7,0,0,1,0-1.29A9.3,9.3,0,0,1,87.08,69.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M57.18,109.79c0,.84,0,1.67,0,2.5s0,1.65,0,2.5a6.07,6.07,0,0,1-.31-2.5A13.15,13.15,0,0,1,57.18,109.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M52.28,114.55a19.7,19.7,0,0,0-.34,2.53,6.32,6.32,0,0,0,.34,2.47,2.69,2.69,0,0,1-.56-1.18,4.44,4.44,0,0,1-.06-1.31A7.71,7.71,0,0,1,52.28,114.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M60.84,115.84a20.5,20.5,0,0,0-.5,2.6,5.31,5.31,0,0,0,0,1.26,2,2,0,0,0,.49,1.14,1.52,1.52,0,0,1-.89-1.06,3.31,3.31,0,0,1-.05-1.4A6.4,6.4,0,0,1,60.84,115.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M62.88,105a22,22,0,0,0-.27,2.53,7.69,7.69,0,0,0,.27,2.47,2.57,2.57,0,0,1-.55-1.18,4.83,4.83,0,0,1-.07-1.31A7.47,7.47,0,0,1,62.88,105Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M56.8,122.82c0,.85,0,1.68,0,2.51s.09,1.61,0,2.49a2.7,2.7,0,0,1-.45-1.22,7.86,7.86,0,0,1,0-1.28A9.16,9.16,0,0,1,56.8,122.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M60.27,85.19c0,.84,0,1.67,0,2.5s0,1.65,0,2.5a6.27,6.27,0,0,1-.32-2.5A14,14,0,0,1,60.27,85.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M55.37,90A18.15,18.15,0,0,0,55,92.47,6.19,6.19,0,0,0,55.37,95a2.69,2.69,0,0,1-.56-1.18,4.83,4.83,0,0,1-.07-1.31A7.72,7.72,0,0,1,55.37,90Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M63.92,91.24a25.09,25.09,0,0,0-.5,2.59,5.3,5.3,0,0,0,0,1.26,2.1,2.1,0,0,0,.49,1.15A1.51,1.51,0,0,1,63,95.18a3.5,3.5,0,0,1-.06-1.4A6.72,6.72,0,0,1,63.92,91.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M66,80.35a24.47,24.47,0,0,0-.26,2.52A8,8,0,0,0,66,85.35a2.83,2.83,0,0,1-.55-1.19,4.73,4.73,0,0,1-.06-1.3A7.45,7.45,0,0,1,66,80.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M59.88,98.21c0,.85,0,1.69,0,2.51s.09,1.62,0,2.5a2.92,2.92,0,0,1-.45-1.22,7.94,7.94,0,0,1,0-1.29A9.3,9.3,0,0,1,59.88,98.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M234.3,263.13s39.42-6.92,64.91-46.31c0,0,11.24-20.85-15.6-18.14,0,0-14.23-24-26.61-10.52a16.93,16.93,0,0,0-4.33,12.89c.9,10.22-.42,33-29.87,33.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M234.3,263.13a90.47,90.47,0,0,0,19.23-6.72,105,105,0,0,0,17.53-10.36,102.8,102.8,0,0,0,15.28-13.43l1.75-1.85c.29-.32.59-.62.87-.94l.81-1L293,224.9c1.12-1.28,2-2.72,3-4.1l2.91-4.18,0,0a20.94,20.94,0,0,0,2.21-7.59,8.53,8.53,0,0,0-2.32-7.1,9.09,9.09,0,0,0-3.31-2,15.06,15.06,0,0,0-1.88-.56c-.65-.12-1.3-.25-2-.32a37.27,37.27,0,0,0-8,.06l-.32,0-.17-.27h0a46.22,46.22,0,0,0-7.82-9.42,22.7,22.7,0,0,0-4.94-3.49,11.29,11.29,0,0,0-5.68-1.33,9.27,9.27,0,0,0-2.83.62,12.25,12.25,0,0,0-2.54,1.49,16,16,0,0,0-3.94,4.48,17,17,0,0,0-2,5.62,15.9,15.9,0,0,0-.23,3c0,1,.12,2,.16,3.09a40.07,40.07,0,0,1-1.37,12.47,25.3,25.3,0,0,1-6.11,10.89,24.79,24.79,0,0,1-10.71,6.33,42.84,42.84,0,0,1-12.32,1.63,42.78,42.78,0,0,0,12.22-2,24.93,24.93,0,0,0,10.38-6.4,24.65,24.65,0,0,0,5.77-10.69A38.87,38.87,0,0,0,252.3,203c-.05-1-.17-2-.21-3.12a17.15,17.15,0,0,1,.2-3.2,17.32,17.32,0,0,1,2.13-6,17,17,0,0,1,4.22-4.83,12.73,12.73,0,0,1,2.8-1.67,10.52,10.52,0,0,1,3.22-.72,12.25,12.25,0,0,1,6.3,1.47,24.12,24.12,0,0,1,5.18,3.69,46.44,46.44,0,0,1,7.89,9.79h0l-.48-.25a38.66,38.66,0,0,1,8.19,0c.68.08,1.36.23,2,.36a15.24,15.24,0,0,1,2,.61,10.08,10.08,0,0,1,3.59,2.18,8,8,0,0,1,2.16,3.63,11.49,11.49,0,0,1,.36,4.16,21.91,21.91,0,0,1-2.37,7.86h0l-3,4.18a50.75,50.75,0,0,1-3.06,4.1l-3.27,3.94-.82,1c-.28.32-.59.62-.88.93L286.73,233a109.08,109.08,0,0,1-33.13,23.58A90.23,90.23,0,0,1,234.3,263.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M278,225.34c.49-.68,1-1.35,1.5-2s1-1.33,1.54-2a6.24,6.24,0,0,1-1.27,2.17A13.69,13.69,0,0,1,278,225.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M284.79,224.54a18.08,18.08,0,0,0,1.8-1.81,6.08,6.08,0,0,0,1.24-2.17,2.71,2.71,0,0,1-.27,1.28,4.53,4.53,0,0,1-.75,1.08A7.36,7.36,0,0,1,284.79,224.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M278.78,218.31a19.73,19.73,0,0,0,2-1.76,5.08,5.08,0,0,0,.76-1,2,2,0,0,0,.31-1.21,1.52,1.52,0,0,1,.06,1.38,3.48,3.48,0,0,1-.81,1.15A6.48,6.48,0,0,1,278.78,218.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M270.55,225.72a25,25,0,0,0,1.74-1.84,8.11,8.11,0,0,0,1.3-2.13,2.66,2.66,0,0,1-.29,1.27,5.11,5.11,0,0,1-.74,1.09A7.58,7.58,0,0,1,270.55,225.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M286.23,215.23l1.56-2c.51-.67.91-1.34,1.48-2a2.9,2.9,0,0,1-.38,1.24,7.31,7.31,0,0,1-.76,1A9,9,0,0,1,286.23,215.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M126.48,283.58c0,.85,0,1.68,0,2.51s.09,1.62,0,2.49a2.83,2.83,0,0,1-.45-1.21,7,7,0,0,1,0-1.29A9.3,9.3,0,0,1,126.48,283.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M114.41,295.06c0,.84,0,1.67,0,2.5s0,1.65,0,2.5a6.47,6.47,0,0,1-.31-2.5A13.15,13.15,0,0,1,114.41,295.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M120.11,290.22a19.94,19.94,0,0,0-.26,2.52,7.74,7.74,0,0,0,.26,2.48,2.61,2.61,0,0,1-.55-1.19,4.79,4.79,0,0,1-.07-1.31A7.47,7.47,0,0,1,120.11,290.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M107.47,337.89s99.2,25.8,127.12-75.85l1.82,11.54s13.76,25.17-16.14,49.83C220.27,323.41,181.94,358.36,107.47,337.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M109.57,243.74S89.7,188.61,153.06,187c0,0,45.31-6.88,46.47,51.95C199.53,239,146.65,219.36,109.57,243.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M128.92,191.71c3.81-2.21,4.11,15.77-.37,18.15-3.24,1.72-8.78-2.37-12.37-6.24a3.79,3.79,0,0,1,1.12-6C121,195.82,126.32,193.21,128.92,191.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M126.3,193.14s5.28,12.06-.2,17.07c0,0,5.05,1.5,5.61-8.4,0,0,1.25-13.58-3.66-9.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M183.34,194.94c4,1.87-9.66,12.44-14.28,10.35s-4.5-13.73-2.69-17.74C166.37,187.55,178,192.45,183.34,194.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.62,193.7s-8.18,11.57-14.31,8.2c0,0,2,7.68,8.85,2.32,0,0,12.25-6.37,8.18-9.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M109,245.41l-.47-1.3c-.35-1-8.43-24,3.2-40.94,7.48-10.94,21.37-16.73,41.28-17.23.57-.1,17.32-2.48,30.94,9,10.65,9,16.25,23.78,16.65,44l0,1.6-1.5-.55c-.52-.2-52.79-19.15-89,4.64Zm47.41-57.52a27.27,27.27,0,0,0-3.21.22c-19.3.49-32.61,6-39.67,16.29-9.48,13.85-4.88,32.57-3.37,37.65,33.5-21,79.36-7.52,88.22-4.61-.64-18.77-6-32.5-15.81-40.82C173.16,188.66,161.85,187.79,156.43,187.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M201.33,248.53c1.27-44.59-26.18-29.5-26.18-29.5-20.84-6.17-36.62,12.71-36.62,12.71l8.79-.33a38.25,38.25,0,0,0,9.34,1.06c10.64-.29,10,8.64,10,8.64C167.75,264,184,261,184,261S201,261.62,201.33,248.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.15,219a24.29,24.29,0,0,1,4.57,3.18,21.3,21.3,0,0,1,3.71,4.21,15.25,15.25,0,0,1,2.17,5.21l.24,1.42,0,1.43c0,.24,0,.48,0,.72l-.09.71-.17,1.43a.5.5,0,1,1-1-.12v-.09l.22-1.33.11-.66c0-.23,0-.45,0-.68l0-1.35-.17-1.34a14.56,14.56,0,0,0-1.87-5.09,20.83,20.83,0,0,0-3.45-4.28A23.67,23.67,0,0,0,175.15,219Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M137.61,187.72a15.23,15.23,0,0,1,4.59,12.73s2.55,9.16,10.18,5.72a12.14,12.14,0,0,0,6.88-10c.24-2.63,1.82-6,7.52-8.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M180.27,224.09s10.33-7.39,17.12.42l-.17-.3c-7.4-13.09-22.07-5-22.07-5-20.83-6.17-36.62,12.71-36.62,12.71S167.92,218.39,180.27,224.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M233.86,263.13s39.42-6.92,64.91-46.31c0,0,11.25-20.85-15.6-18.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M233.86,263.13a90,90,0,0,0,19.2-6.79,105.6,105.6,0,0,0,17.48-10.42,103.53,103.53,0,0,0,15.2-13.47l1.74-1.85c.29-.31.59-.61.87-.93l.8-1,3.2-3.95a48.23,48.23,0,0,0,3-4.09l2.94-4.15,0,0a21.57,21.57,0,0,0,2.31-7.48,8.59,8.59,0,0,0-2.2-7.14,9.38,9.38,0,0,0-3.29-2.07,17.35,17.35,0,0,0-1.89-.61c-.65-.13-1.31-.28-2-.37a38.05,38.05,0,0,0-8.06-.19,38,38,0,0,1,8.12-.24c.67.06,1.35.19,2,.3a17.3,17.3,0,0,1,2,.56,10,10,0,0,1,3.6,2.08,7.84,7.84,0,0,1,2.22,3.58,11.57,11.57,0,0,1,.42,4.17,21.39,21.39,0,0,1-2.26,8v0l-2.94,4.21a49.32,49.32,0,0,1-3.07,4.11L290,229.39l-.82,1c-.29.32-.59.62-.89.93l-1.78,1.85a104.41,104.41,0,0,1-15.54,13.32,105.67,105.67,0,0,1-17.73,10.17A90,90,0,0,1,233.86,263.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M277.58,225.34c.49-.68,1-1.35,1.49-2a23.79,23.79,0,0,1,1.55-2,6.26,6.26,0,0,1-1.28,2.17A13,13,0,0,1,277.58,225.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M284.36,224.54a18.08,18.08,0,0,0,1.8-1.81,6.08,6.08,0,0,0,1.24-2.17,2.6,2.6,0,0,1-.28,1.28,4.23,4.23,0,0,1-.74,1.08A7.67,7.67,0,0,1,284.36,224.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M278.35,218.31a19.73,19.73,0,0,0,2-1.76,5.5,5.5,0,0,0,.76-1,2.15,2.15,0,0,0,.31-1.21,1.55,1.55,0,0,1,.06,1.38,3.48,3.48,0,0,1-.81,1.15A6.48,6.48,0,0,1,278.35,218.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M270.11,225.72a23.18,23.18,0,0,0,1.75-1.84,8.08,8.08,0,0,0,1.29-2.13,2.65,2.65,0,0,1-.28,1.27,5.11,5.11,0,0,1-.74,1.09A7.47,7.47,0,0,1,270.11,225.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M285.8,215.23c.53-.67,1.05-1.32,1.55-2s.91-1.34,1.48-2a2.65,2.65,0,0,1-.38,1.24,6.56,6.56,0,0,1-.75,1A9.3,9.3,0,0,1,285.8,215.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M123.5,31.37S52,52.55,56.8,122.82l-12.58-5.77S35.77,48.84,123.5,31.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.7,263.8s-39.32-7.47-64.25-47.22c0,0-11-21,15.85-17.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M67.7,263.8A90.87,90.87,0,0,1,48.46,257a109.36,109.36,0,0,1-32.95-24c-2.52-2.33-4.71-5-7-7.52a43,43,0,0,1-3.19-4q-1.53-2.09-3-4.22l0,0,0,0a21.54,21.54,0,0,1-1.52-4A19.45,19.45,0,0,1,0,208.91a12,12,0,0,1,.56-4.43,8.51,8.51,0,0,1,2.52-3.8A10.47,10.47,0,0,1,7,198.6a17.73,17.73,0,0,1,4.16-.69,32.2,32.2,0,0,1,8.16.76,45.32,45.32,0,0,0-8,.48c-.65.1-1.28.26-1.92.41a15.46,15.46,0,0,0-1.81.63,8.67,8.67,0,0,0-3.07,2,8,8,0,0,0-2,6.59A21.57,21.57,0,0,0,4.64,216l0-.09c.94,1.39,1.87,2.79,2.77,4.22s1.73,2.89,2.76,4.23l3,4.13.75,1c.26.33.54.64.81,1l1.64,1.94a102,102,0,0,0,15,13.69A105.4,105.4,0,0,0,48.6,256.74,90.92,90.92,0,0,0,67.7,263.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M45,235.63c-.48-.69-1-1.36-1.47-2s-.95-1.34-1.51-2a6.1,6.1,0,0,0,1.24,2.19A13,13,0,0,0,45,235.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M38.21,234.73a19.09,19.09,0,0,1-1.78-1.82,6.16,6.16,0,0,1-1.2-2.19,2.69,2.69,0,0,0,.25,1.28,4.52,4.52,0,0,0,.73,1.09A7.31,7.31,0,0,0,38.21,234.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M44.31,228.59a22.29,22.29,0,0,1-2-1.78,5.51,5.51,0,0,1-.75-1,2.17,2.17,0,0,1-.29-1.22,1.52,1.52,0,0,0-.07,1.38,3.32,3.32,0,0,0,.79,1.16A6.39,6.39,0,0,0,44.31,228.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M52.44,236.12a21.52,21.52,0,0,1-1.72-1.87,8,8,0,0,1-1.27-2.15,2.84,2.84,0,0,0,.27,1.28,4.78,4.78,0,0,0,.73,1.1A7.85,7.85,0,0,0,52.44,236.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M36.9,225.41l-1.53-2c-.5-.67-.89-1.36-1.45-2a2.83,2.83,0,0,0,.36,1.25,7.91,7.91,0,0,0,.74,1.05A9.59,9.59,0,0,0,36.9,225.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M38.74,218.88c-.48-.69-1-1.36-1.46-2s-1-1.34-1.52-2A6.34,6.34,0,0,0,37,217.06,13.62,13.62,0,0,0,38.74,218.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M32,218a17.85,17.85,0,0,1-1.77-1.82A6.12,6.12,0,0,1,29,214a2.61,2.61,0,0,0,.26,1.28,4,4,0,0,0,.73,1.09A7.3,7.3,0,0,0,32,218Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M38.07,211.84a22.29,22.29,0,0,1-2-1.78,5.51,5.51,0,0,1-.74-1,2,2,0,0,1-.29-1.21,1.49,1.49,0,0,0-.08,1.38,3.33,3.33,0,0,0,.79,1.15A6.65,6.65,0,0,0,38.07,211.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M46.2,219.36a21.41,21.41,0,0,1-1.72-1.86,8.26,8.26,0,0,1-1.26-2.15,2.59,2.59,0,0,0,.27,1.28,4.48,4.48,0,0,0,.72,1.09A7.45,7.45,0,0,0,46.2,219.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M30.67,208.65c-.53-.67-1-1.32-1.53-2s-.89-1.35-1.46-2a2.84,2.84,0,0,0,.37,1.24,7.08,7.08,0,0,0,.74,1.05A8.79,8.79,0,0,0,30.67,208.65Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.de32c9ad88f5e04f356a8a1e998ecee5.svg";
export { ForwardRef as ReactComponent };